<div class="field" [class.error]="termsAndConditionsError">
  <ui-checkbox [checked]="termsAndConditionsChecked" (checkedChange)="onClickTerms($event)">
    <span [innerHTML]="'txt_accept_terms_and_conditions_checkbox' | translate"></span>
  </ui-checkbox>
  <gd-form-field-error-message
    [errorMessage]="termsAndConditionsError ? ('txt_form_validation_blank_field_message' | translate) : null"
  >
  </gd-form-field-error-message>
</div>

<div class="field">
  <ui-checkbox [checked]="receiveNewsChecked" (checkedChange)="onClickReceiveNews($event)">
    {{ 'txt_receive_news_checkbox' | translate }}
  </ui-checkbox>
</div>
